(function () {
  var SOURCE = /\s*NIS\b/g;
  var SYMBOL = '₪';

  function rewrite(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.nodeValue && node.nodeValue.indexOf('NIS') !== -1) {
        var trimmed = node.nodeValue.replace(SOURCE, '').replace(/\s+$/g, '');
        var hasNumber = /\d/.test(trimmed);
        node.nodeValue = hasNumber ? SYMBOL + trimmed.replace(/^\s+/, '') : trimmed.replace('NIS', SYMBOL);
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    var tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;
    for (var i = 0; i < node.childNodes.length; i++) {
      rewrite(node.childNodes[i]);
    }
  }

  function run() {
    rewrite(document.body);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          rewrite(m.addedNodes[j]);
        }
        if (m.type === 'characterData') {
          rewrite(m.target);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
